export type SearchSavedBaseEvent = typeof SEARCH_SAVED_BASE_EVENT;

export const SEARCH_SAVED_BASE_EVENT = `search:saved`;

export const SEARCH_SAVED_EVENT = <const>{
	CREATE: `${SEARCH_SAVED_BASE_EVENT}:create`,
	CREATE_PDF: `${SEARCH_SAVED_BASE_EVENT}:createPDF`,
	CREATE_PDF_SHARE_LINK: `${SEARCH_SAVED_BASE_EVENT}:createPDF:shareLink`,
	CREATE_PDF_DOWNLOAD: `${SEARCH_SAVED_BASE_EVENT}:createPDF:download`,
	DELETE: `${SEARCH_SAVED_BASE_EVENT}:delete:react`,
	DOWNLOAD: `${SEARCH_SAVED_BASE_EVENT}:download`,
	MENU: `${SEARCH_SAVED_BASE_EVENT}:menu`,
	SHARE_LINK: `${SEARCH_SAVED_BASE_EVENT}:share:link`,
	SHARE_TEAM_ACCESS: `${SEARCH_SAVED_BASE_EVENT}:share:teamAccess`,
	// SHARE_WITH_TEAM: `${SEARCH_SAVED_BASE_EVENT}:share:users`,
	RENAME: `${SEARCH_SAVED_BASE_EVENT}:rename:react`,
	TOGGLE_FAVORITE: `${SEARCH_SAVED_BASE_EVENT}:toggle:favorite`,
	VIEW: `${SEARCH_SAVED_BASE_EVENT}:view`,
};
